import { Router, Route, Switch, Redirect } from 'react-router-dom';
import React from 'react';
import { UserContext } from './../Context/UserContext';
import history from './../Utils/history';
import { Login, Logout, NotFound, LocationDetails } from '../Pages';
import { UserRoles } from '../Constants/constants';
import { Helper } from '../Utils';
import ApplicationLayout from '../Layout/ApplicationLayout';
import { ExternalLogin, Users, User, Devices, Device, Locations } from '../Pages/index';
import { useTranslation } from 'react-i18next';
import { routes } from './routes';
import Graphics from '../Pages/Graphics/Graphics';
import { Goals } from '../Pages/Goal/Goals';
import { Rules } from '../Pages/Rule/Rules';

const AppRouter: React.FC = () => {
	const { t } = useTranslation();

	return (
		<Router history={history}>
			<React.Fragment>
				<Switch>
					<SecuredAppRoute
						userRole={UserRoles.atLeastLocationAdmin}
						exact
						title={t('locations.pageTitle')}
						layout={ApplicationLayout}
						path={routes.locations}
						render={() => <Locations />}
					/>
					<SecuredAppRoute
						userRole={UserRoles.atLeastLocationAdmin}
						exact
						title={t('locations.pageTitle')}
						layout={ApplicationLayout}
						path={routes.root}
						render={() => <Locations />}
					/>
					<SecuredAppRoute
						path={routes.locationDetails}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={LocationDetails}
					/>
					<SecuredAppRoute
						userRole={UserRoles.atLeastLocationAdmin}
						exact
						title={t('users.pageTitle')}
						layout={ApplicationLayout}
						path={routes.users}
						render={() => <Users />}
					/>
					<SecuredAppRoute
						path={routes.userDetails}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={User}
					/>
					<SecuredAppRoute
						path={routes.deviceDetails}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={Device}
					/>
					<SecuredAppRoute
						userRole={UserRoles.atLeastLocationAdmin}
						exact
						title={t('devices.pageTitle')}
						layout={ApplicationLayout}
						path={routes.devices}
						render={() => <Devices />}
					/>
					<SecuredAppRoute
						path={routes.graphics}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={Graphics}
					/>
					<SecuredAppRoute
						path={routes.goals}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={Goals}
					/>
					<SecuredAppRoute
						path={routes.rules}
						layout={ApplicationLayout}
						userRole={UserRoles.atLeastLocationAdmin}
						render={Rules}
					/>
					<AppRoute exact path={routes.login} layout={ApplicationLayout} render={Login} />
					<AppRoute layout={React.Fragment} exact path={routes.externalLogin} render={() => <ExternalLogin />} />
					<AppRoute
						layout={ApplicationLayout}
						exact
						path={routes.logout}
						render={() => (Helper.isLoggedIn() ? <Logout /> : <Login />)}
					/>
					<AppRoute path='*' layout={ApplicationLayout} render={() => (Helper.isLoggedIn() ? <NotFound /> : <Login />)} />
				</Switch>
			</React.Fragment>
		</Router>
	);
};

//@ts-ignore
const AppRoute = ({ render: Component, layout: ApplicationLayout, ...rest }) => (
	<Route
		render={() => (
			<ApplicationLayout>
				<Component {...rest} />
			</ApplicationLayout>
		)}
	/>
);

//@ts-ignore //delete title
const SecuredAppRoute = ({ render: Component, layout: ApplicationLayout, userRole: UserRole, title = '', ...rest }) => {
	const userContext = React.useContext(UserContext);

	const isInRole = (roles: string[]) => {
		let isInRole = false;
		if (typeof roles === 'string') roles = [roles];
		roles.forEach((role: string) => {
			if (userContext.userRoles?.findIndex((r) => r === role) >= 0) {
				isInRole = true;
				return;
			}
		});

		return isInRole;
	};

	if (userContext.isLogged === false) {
		return <Redirect to={routes.login} />;
	}

	if (isInRole(UserRole) === false) {
		return (
			<Route {...rest}>
				<ApplicationLayout>
					<NotFound />
				</ApplicationLayout>
			</Route>
		);
	}

	return (
		<Route {...rest}>
			<ApplicationLayout location={rest.location.pathname} title={title}>
				<Component />
			</ApplicationLayout>
		</Route>
	);
};

export default AppRouter;
